module.exports = __webpack_public_path__ + "static/media/duo-lockup-header-light.e2ff31d0.svg";